import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import store from './store/store';
import './styles/main.scss';
import { queryClient } from './utils/reactQuery';

//registerServiceWorker.register();

const DndProviderWithChildren = DndProvider as React.ComponentType<
    React.PropsWithChildren<React.ComponentProps<typeof DndProvider>>
>;
const rootElement = document.getElementById('root');

if (!rootElement) {
    throw new Error('Root element not found');
}

createRoot(rootElement).render(
    <Provider store={store}>
        <BrowserRouter basename="/">
            <DndProviderWithChildren backend={HTML5Backend}>
                <CssBaseline>
                    <QueryClientProvider client={queryClient}>
                        <LocalizationProvider dateAdapter={AdapterLuxon}>
                            <App />
                            <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
                        </LocalizationProvider>
                    </QueryClientProvider>
                </CssBaseline>
            </DndProviderWithChildren>
        </BrowserRouter>
    </Provider>,
);

//~ -----------------------------------------------------------
//~ Helpful Articles Used During Development
//~ -----------------------------------------------------------
//~
//~     React-Redux Hooks
//~     https://react-redux.js.org/next/api/hooks
//~
//~     React, Redux with TypeScript
//~     https://redux.js.org/recipes/usage-with-typescript
//~     https://www.typescriptlang.org/docs/handbook/react.html
//~
//~     React-Dnd
//~     https://react-dnd.github.io/react-dnd/about
